import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaVideo, FaLaptopCode, FaShieldAlt, FaDatabase, FaNetworkWired, FaBell, FaKey, FaEye, FaComments, FaWrench, FaUserShield, FaTools, FaSync, FaLaptop, FaHeadset } from 'react-icons/fa';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'cctv installation':
      return <FaVideo />; // Video icon representing CCTV installation services

    case 'system integration':
      return <FaNetworkWired />; // Network icon representing system integration

    case 'alarm systems':
      return <FaBell />; // Bell icon representing alarm and security systems

    case 'access control':
      return <FaKey />; // Key icon representing access control systems

    case 'monitoring services':
      return <FaEye />; // Eye icon representing surveillance and monitoring services

    case 'security consultation':
      return <FaComments />; // Comments icon representing security consultation services

    /*----- Position Icons -----*/
    case 'cctv installation technician':
      return <FaVideo />; // Video icon representing CCTV installation technician

    case 'security systems engineer':
      return <FaShieldAlt />; // Shield icon representing security systems engineering

    case 'cctv maintenance specialist':
      return <FaWrench />; // Wrench icon representing CCTV maintenance services

    case 'security consultant':
      return <FaUserShield />; // User Shield icon representing a security consultant

    case 'security software developer':
      return <FaLaptopCode />; // Laptop Code icon representing security software development

    case 'network security specialist':
      return <FaNetworkWired />; // Network icon representing network security specialists

    /*----- Support Button Icons -----*/
    case 'cctv support':
      return <FaVideo />; // Video icon representing CCTV support services

    case 'installation guides':
      return <FaTools />; // Tools icon representing installation guides and manuals

    case 'security updates':
      return <FaSync />; // Sync icon representing security updates

    case 'camera issues':
      return <FaWrench />; // Wrench icon representing troubleshooting camera issues

    case 'remote access':
      return <FaLaptop />; // Laptop icon representing remote access services

    case 'data storage':
      return <FaDatabase />; // Database icon representing data storage solutions

    case 'motion sensors':
      return <FaBell />; // Bell icon representing motion sensor alarms

    case 'technical support':
      return <FaHeadset />; // Headset icon representing technical support services

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon representing date and deadlines

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon representing time and schedules

    case 'duration':
      return <FaClock />; // Clock icon representing the duration of an event or task

    case 'beneficiaries':
    case 'position':
      return <FaUsers />; // Users icon representing individuals in a position or role

    case 'category':
      return <FaTags />; // Tags icon representing different service categories

    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon representing physical locations

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar sign icon representing costs, pricing, or salary

    case 'experience':
      return <FaBriefcase />; // Briefcase icon representing work experience

    case 'projectlead':
      return <FaUserTie />; // User Tie icon representing a project lead or manager

    case 'number':
      return <FaPhone />; // Phone icon representing contact numbers

    case 'email':
      return <FaEnvelope />; // Envelope icon representing email communication

    default:
      return null; // Return null if no matching icon is found
  }
};